<lc-base-dialog class="fx-fill" [title]="data?.title || 'PDF View'" (actionClicked)="onClose()">

  <ng-template #content>
    <div class="pdf-container">
      @if (safeUrl) {
        <iframe [src]="safeUrl"></iframe>
      }
    </div>
  </ng-template>
</lc-base-dialog>
